import { getThemeType } from './getThemeType';
import { useThemeValue } from './useThemeValue';
export function useThemeType() {
    return getThemeType(useThemeValue());
}
